const ibantools = require('ibantools')
const inputEmptyErrorFallback = 'Field cannot be empty'
const inputFormatErrorFallback = 'Check input format'

export function validateAll (e, errorEmptyText, errorFormatText) {
    e.preventDefault()
    e.stopPropagation()

    this.setState({
        error: ''
    })

    if (e.target.validity.valueMissing) {
        this.setState({
            error: errorEmptyText || inputEmptyErrorFallback
        })
    }

    if (e.target.validity.patternMismatch) {
        this.setState({
            error: errorFormatText || inputFormatErrorFallback
        })
    }

    if (e.target.form.querySelectorAll(':invalid').length > 0) {
        e.target.form.querySelectorAll(':invalid')[0].focus()
    }
}

export function validateEmpty (e, errorText) {
    this.setState({
        error: ''
    })

    const isValid = !e.target.validity.valueMissing

    if (!isValid) {
        this.setState({
            error: errorText || inputEmptyErrorFallback
        })
    }

    return isValid
}

export function validateWithoutFocus (e, errorEmptyText, errorFormatText) {
    e.preventDefault()
    e.stopPropagation()

    let error = ''

    if (e.target.validity.valueMissing) {
        error = errorEmptyText || inputEmptyErrorFallback
    }

    if (e.target.validity.patternMismatch) {
        error = errorFormatText || inputFormatErrorFallback
    }

    this.setState({
        error
    })
}

export function validateRange (e, errorText) {
    e.preventDefault()
    e.stopPropagation()

    const isValid = !(e.target.validity.rangeUnderflow || e.target.validity.rangeOverflow)

    this.setState({
        error: !isValid ? errorText : ''
    })

    return isValid
}

export function validateEmail (email) {
// eslint-disable-next-line no-useless-escape
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

    return re.test(email)
}

export function validateZip (zip) {
    return zip && !isNaN(zip) && zip.length === 5
}

export function validateIban (value) {
    const { t } = this.props
    const iban = ibantools.electronicFormatIBAN(value)
    const isValid = ibantools.isValidIBAN(iban)

    const ibanValidationError = !isValid ? t('formElements:bankAccountNumber.validationError') : false

    this.setState({
        ibanValidationError
    })

    return isValid
}

export function validateTextLength (text, length) {
    const { t } = this.props
    const isValid = text.length <= length

    const textLengthError = !isValid ? t('formElements:global.textLengthValidationError', { length: length }) : false

    this.setState({
        textLengthError
    })

    return isValid
}
